import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { home } from "../../const";
import Footer from "./Footer";
import LastLocation from "./LastLocation";
import NavbarWithDrawer from "./NavbarWithDrawer";

const PrivacyPolicy = () => {
  let width = window.innerWidth;
  return (
    <>
      {/* <Row className="bg-themesecond shadow-none p-2 align-items-center">
            <Col md={1} sm={1} xs={1}>
              <h4 className="mb-0">
                <LastLocation />
              </h4>
            </Col>
          </Row> */}
      {localStorage.getItem("x-auth-token") && <NavbarWithDrawer />}
      <div className={`container-fluid ${localStorage.getItem('x-auth-token') && 'mt-5'}`}>
        <div className="p-5 mbl-pedding-10">
          {/* <Row>
            <Col md={12} className="text-center">
              <Link to={home}>
                <img
                  className={`${width > 468 ? `w-10` : `w-50`}`}
                  src={siteLogo}
                  alt={"Site Logo"}
                />
              </Link>
            </Col>
          </Row> */}
          <Row className="mt-2">
            <Col md={12} className="page-main">
              <h1 className="mb-4">Privacy Policy</h1>
              <p>{process.env.REACT_APP_SITE_NAME} values your privacy. We collect only essential information to make your experience smooth and secure.</p>
              <p className="mb-0 mt-2"><b>What We Collect:</b></p>
              <ul>
                <li>Phone number (for login and OTP verification)</li>
                <li>Media (if you choose to send images or videos)</li>
                <li>Device information (for security and performance)</li>
              </ul>
              <p className="mb-0 mt-2"><b>How We Use It:</b></p>
              <ul>
                <li>To verify your identity</li>
                <li>To deliver chat functionality</li>
                <li>To ensure multi-device access securely</li>
              </ul>
              <p className="mb-0 mt-2"><b>What We Don’t Do:</b></p>
              <ul>
                <li>We do not share your personal data with third parties</li>
                <li>We do not show ads</li>
                <li>We do not access your data without permission</li>
              </ul>
              <p>Your conversations are stored securely and are only visible to you and the leaders you message.</p>
              <p>If you have any questions, contact us at {process.env.REACT_APP_SUPPORT_EMAIL}</p>
            </Col>
          </Row>
        </div>
      </div>
      {localStorage.getItem("x-auth-token") && <Footer />}
    </>
  );
};

export default PrivacyPolicy;
